export default __webpack_public_path__ + "static/media/2-1.9a49e643.png";